module.exports = __webpack_public_path__ + "media/images/content/pic_direction_e-bd3b959e979d8f9aafb6262c7c5d38c8.svg";